import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const User = () => {
  const navigate = useNavigate();
  const [listData, setListData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchParam] = useState(["gst_no", "name", "city", "state_name", "party_type"]);
  const [isAllowed, setIsAllowed] = useState(false)

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
        if (res.data) {
            setIsAllowed(res.data.is_allowed);
            if (res.data.is_allowed) {
              fetchListData();
            } else {
              navigate("/admin/dashboard", { replace: true });
            }
        }
    });
  }

  const fetchListData = () => {
    axios.post(API_URL.USER_LIST).then(
      (res) => {
        if (res.data.status === 1) {
          setListData(res.data.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-center",
        });
      }
    );
  };

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.USER_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = listData.filter((r) => r.id != row.id);
              setListData(newData);
            }
            toast.success("Delete Successfully", {
              autoClose: 3000,
              position: "top-center",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-center",
            });
          }
        );
      }
    });
  };

  const search = (items) => {
    return items.filter((item) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem] && item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) > -1
        );
      });
    })
  }

  useEffect(() => {
    userInfo();
  }, []);
  return (
    <>
      {isAllowed && <PageHeader
        pageTitle={"User"}
        count={listData.length}
        addPageUrl={"/admin/user/add"}
      /> }
      {isAllowed && <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
            {loading && <Loader></Loader>}
            {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Location</th>
                          <th>Email</th>
                          <th>Contact</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {search(listData).map((row, key) => {
                          return (
                            <tr key={key}>
                              <td className="td-hash">{key + 1}</td>
                              <td>
                                {row.name}
                              </td>
                              <td>
                                {row.city}, {row.state_name}
                              </td>
                              <td>{row.email}</td>
                              <td>{row.contact_no}</td>
                              <td className="td-action">
                              <div>
                                <Link
                                  to={"/admin/user/edit/" + row.id}
                                  className="btn btn-sm btn-secondary"
                                >
                                  <i className="fa fa-edit"></i>
                                </Link>
                                <button
                                  onClick={() => deleteParty(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div> }
    </>
  );
};

export default User;
